import React, { useState } from "react";
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import OrderSection from "../../update_pharmacy_customer/components/order/components/create_order/OrderSection";
import { DataAccordion } from "../components";
import { COLORS, BUTTON_STYLES } from "../styles/theme";
import { INewRxStepHandoff } from "../types/PrescriptionIngestionTypes";

interface IProps {
  // Context carried from the Approve step via Continue. Absent when the user lands
  // here directly, in which case OrderSection's own Person Id field is used.
  handoff?: INewRxStepHandoff;
}

const nextStepButtonStyle = BUTTON_STYLES.nextStep;

/**
 * Step 4 of the NewRx Operations flow: create an order for the customer. Reuses the
 * existing Create Order section, prefilled with the personId from the handoff when
 * reached via Continue. On success it collapses into a summary accordion.
 */
const CreateOrderStepSection: React.FC<IProps> = ({ handoff }) => {
  const [showOrder, setShowOrder] = useState(false);
  const [orderResponse, setOrderResponse] = useState<any>(null);

  const personId = handoff?.personId;

  // Once the order succeeds, render a plain summary accordion matching steps 1-3
  // (no orange action panel).
  if (orderResponse) {
    return (
      <Grid container direction="column" spacing={3} style={{ marginTop: 8 }}>
        <DataAccordion
          title="4. Create Order"
          data={orderResponse}
          defaultExpanded
        />
      </Grid>
    );
  }

  return (
    <Grid container direction="column" spacing={3} style={{ marginTop: 8 }}>
      <Grid item xs={12} style={{ width: "100%", maxWidth: 1200 }}>
        <Paper style={{ padding: 24, backgroundColor: "#fff3e0" }}>
          <Typography variant="h6" gutterBottom>
            4. Create Order
          </Typography>

          <div style={{ marginBottom: 16 }}>
            <Alert severity="warning">
              Please continue with this step after 1 min once step 3 above is
              done (the approval needs time to propagate).
            </Alert>
          </div>

          {!handoff && (
            <div style={{ marginBottom: 16 }}>
              <Alert severity="info">
                Enter the Person Id below to load the customer's prescriptions,
                address, and payment options. This comes from the customer created
                during the earlier steps.
              </Alert>
            </div>
          )}

          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            <Button
              variant="outlined"
              aria-expanded={showOrder}
              onClick={() => setShowOrder((show) => !show)}
              style={nextStepButtonStyle}
            >
              {showOrder ? "Hide" : "Create Order"}
            </Button>
          </div>

          {showOrder && (
            <div style={{ marginTop: 24 }}>
              <OrderSection
                initialPersonId={personId}
                initialPrescriptionId={handoff?.prescriptionId}
                submitColor={COLORS.orange}
                onSuccess={(response: any) => {
                  setOrderResponse(response);
                  setShowOrder(false);
                }}
              />
            </div>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default CreateOrderStepSection;
